import { useMemo } from 'react'
import { useGetSetting } from 'api/settings'

export const useGetIsPortalHidden = () => {
  const { setting } = useGetSetting()
  return useMemo(() => setting?.isPortalHidden, [setting])
}
